export default "__VITE_ASSET__6H5XlvSa__"